import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Sidebar from './AnimatedList';
import "./Services.css";
import "./ServicePage.css";
import Banner from "../Img/Services Banner/Services Banner.jpg";

function AirChartering() {
  return (
    <>
      <Image className="fade-in responsive-img" src={Banner} height={500} width="100%" fluid />

      <div className="service-page">
        <section className="service-hero">
          <span className="service-hero__eyebrow">Our Services</span>
          <h1 className="service-hero__title">
            Air <span>Freight</span>
          </h1>
          <p className="service-hero__subtitle">
            Complete air freight and chartering services worldwide — for regular,
            special, temperature-controlled and oversized cargo, backed by a large
            network of local agents.
          </p>
        </section>

        <div className="service-layout">
          <article className="service-content">
            <h2>Complete Air Freight Solutions</h2>
            <p>
              <strong>MMOPL</strong> offers complete air freight and chartering services worldwide
              for every type of cargo. Whether you want to ship regular cargo, special cargo such as
              dangerous goods, temperature-controlled goods or oversized goods — we are backed by a
              large network of local agents that guarantee the smooth transport of your goods.
            </p>

            <h2>One-Stop Solutions</h2>
            <p>
              Because we are part of a group with a wide range of services, we can also offer you
              various one-stop solutions. We take care of the entire logistics process for you —
              from collection at the factory, via road transport to the airport, complete customs
              formalities, and final delivery to your doorstep. MMOPL monitors the process from
              A to Z and keeps you informed at every stage, so you can continue to focus on your
              most important business activities.
            </p>

            <h2>What We Handle</h2>
            <ul className="service-features">
              <li>Regular cargo and consolidated air shipments</li>
              <li>Dangerous goods (IATA-compliant) and temperature-controlled cargo</li>
              <li>Oversized and heavy-lift air chartering</li>
              <li>Door-to-door service with complete customs documentation</li>
              <li>Real-time shipment tracking and status updates</li>
            </ul>

            <div className="service-info-banner">
              <div className="service-info-banner__icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z" />
                </svg>
              </div>
              <p>
                <strong>Time-critical shipments:</strong> When speed matters, our air freight team
                arranges priority uplift, express customs clearance and same-day pickup.
              </p>
            </div>

            <div className="service-cta">
              <h3>Ship Urgent Cargo with Confidence</h3>
              <p>
                Send us your origin, destination, weight and commodity — we'll confirm
                air freight pricing and transit time within a few hours.
              </p>
              <Link to="/Contact" className="service-cta__btn">
                Request a Quote
              </Link>
            </div>
          </article>

          <Sidebar />
        </div>
      </div>
    </>
  );
}

export default AirChartering;